import {useLocation, useNavigate} from "react-router-dom";
import {use, useCallback, useEffect, useMemo, useState} from "react";
import {useForm} from "react-hook-form";
import {states} from "../shared/StatesDropdown";
import FormSelectCustom from "../shared/components/FormSelectCustom";
import {customerService} from "../services/customerService";
import NewEditTruckModal from "../components/customer-management/NewEditTruckModal";
import NewJobModal from "../components/customer-management/NewJobModal";
import LinkCCModal from "../components/customer-management/LinkCCModal";
import {businessYearService} from "../services/businessYearService";
import notificationService from "../services/NotificationService";
import {listService} from "../services/listsService";
import {authorize_net_client_key, authorize_net_login_id, google_api_key} from "../services/common.services";
import AutocompleteAddressInput from "../shared/components/AutocompleteAddressInput";
import {
    formatStandardizedAddress, getBusinessOrCustomerName, getCardType, isNullOrEmpty,
    SplitAddressFromGoogleAddressComponents,
    splitAddressIntoStreetAndCityStateZip
} from "../shared/sharedFunctions";
import {getValue} from "@testing-library/user-event/dist/utils";
import eventEmitter from "../shared/eventEmitter";
import {EventEmitterTypes} from "../shared/eventEmitterEnum";
import BillingInfoModal from "../components/customer-management/BillingInfoModal";
import {useAcceptJS} from "../shared/UseAcceptJS";
import {publicCustomerService} from "../services/publicCustomerService";

const CustomerDetailsPage: React.FC = () => {
    const { register, reset, getValues, setValue, handleSubmit, watch, formState: { dirtyFields, errors } } = useForm();
    const {state} = useLocation();
    const navigate = useNavigate();
    const [customerData, setCustomerData] = useState<any>(null);
    const [linkedAddresses, setLinkedAddresses] = useState<any>(null);
    const [place, setPlace] = useState<any>(null);
    const [fullBillingAddress, setFullBillingAddress] = useState<any>(null);
    const [billingModalInfo, setBillingModalInfo] = useState<any>(null);
    const [jobData, setJobData] = useState([]);
    const [showJobModal, setShowJobModal] = useState(false);
    const [showCCModal, setShowCCModal] = useState(false);
    const [showBillingModal, setShowBillingModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [placeChanged, setPlaceChanged] = useState(false);
    const [currentYear, setCurrentYear] = useState(2025);
    const [customerStatusOptions, setCustomerStatuses] = useState([]);
    const [updateCustomerIdBillingInfo, setUpdateCustomerIdBillingInfo] = useState([]);
    const [billingInfoUpdate, setBillingInfoUpdate] = useState(null);
    const [mapBase64String, setMapBase64String] = useState('')
    const { loaded, error, accept } = useAcceptJS();

    function onTokenReceived(dataValue, dataDescriptor, customerID) {
        const parts = billingInfoUpdate.expDate.split('/');
        if (parts.length !== 2) {
            notificationService.error("Invalid expiration format. Expected MM/YY.");
            return;
        }
        const [month, year] = parts;
        let normalizedYear = year;
        if (year.length === 2) {
            normalizedYear = `20${year}`;
        }
        const billingPostObj = {
            customerIds: [customerID],
            billingName: billingInfoUpdate.name,
            billingAddress: billingInfoUpdate.billingAddress,
            billingCity: billingInfoUpdate.billingCity,
            billingState: billingInfoUpdate.billingState,
            billingPostalCode: billingInfoUpdate.billingPostalCode,
            paymentTokenDescriptor: dataDescriptor,
            paymentToken: dataValue,
            cardLast4: billingInfoUpdate.cardNumber.replace(/\s+/g, "").slice(-4),
            cardExpirationMonth: month,
            cardExpirationYear: normalizedYear,
            cardType: getCardType(billingInfoUpdate.cardNumber)
        }
        return customerService.updateBillingInfo(billingPostObj).then(r => {
            if(r.failedCount > 0){
                notificationService.error(`Failed to save for customer ID ${customerID}`)
            }
        });

    }
    async function processNext(index: number, secureData: any) {
        if (index >= updateCustomerIdBillingInfo.length) {
            setUpdateCustomerIdBillingInfo([]);
            return;
        }
        const customerId = updateCustomerIdBillingInfo[index];
        await new Promise<void>((resolve) => {
            const callback = (response: any) => {
                if (response.messages.resultCode === "Error") {
                    const msg = response.messages.message[0];
                    console.error(`${msg.code}: ${msg.text}`);
                    notificationService.error(msg.text);
                    resolve();
                } else {
                    const { dataValue, dataDescriptor } = response.opaqueData;
                    onTokenReceived(dataValue, dataDescriptor, customerId).finally(resolve);
                }
            };

            accept.dispatchData(secureData, callback);
        });
        await processNext(index + 1, secureData);
    }
    const onSubmit = data => {
        if(placeChanged){
            GetStaticImageOfCustomer(data).then(r =>{})
            customerService.saveMapAreaByCustomerId(data.customerId, []).then(r => {})
        }
        if(updateCustomerIdBillingInfo.length > 0){
            const authData = {
                clientKey: authorize_net_client_key,
                apiLoginID: authorize_net_login_id,
            };
            const parts = billingInfoUpdate.expDate.split('/');
            if (parts.length !== 2) {
                notificationService.error("Invalid expiration format. Expected MM/YY.");
                return;
            }
            const [month, year] = parts;
            let normalizedYear = year;
            if (year.length === 2) {
                normalizedYear = `20${year}`;
            }
            const cardData = { cardNumber: billingInfoUpdate.cardNumber.replace(/\s/g, ''), month, year: normalizedYear, cardCode: billingInfoUpdate.securityCode };
            const billing = { fullName: billingInfoUpdate.name};

            const secureData = { authData, cardData, billing };

            processNext(0, secureData).then(r => {})
            
            /*const callback = (response: any) => {
                if (response.messages.resultCode === "Error") {
                    const msg = response.messages.message[0];
                    console.log(`${msg.code}: ${msg.text}`);
                    notificationService.error(msg.text)
                } else {
                    const { dataValue, dataDescriptor } = response.opaqueData;
                    onTokenReceived(dataValue, dataDescriptor);
                }
            };

            accept.dispatchData(secureData, callback);*/
        }
        const status = customerStatusOptions.find(x => x.value === Number(data.customerStatusId))
        data.customerStatusId = status?.value;
        data.customerStatusName = status?.label;
        if(data.email == "") data.email = null;
        customerService.saveCustomer(data).then(r => {
            notificationService.success("Customer Saved");
            reset(data)
        });
    }

    useEffect(() => {
        if(billingInfoUpdate) {
            setValue("billingName", billingInfoUpdate.name, {
                shouldDirty: true,
            });
            setValue("billingAddress", billingInfoUpdate.billingAddress, {
                shouldDirty: true,
            });
            setValue("billingCity", billingInfoUpdate.billingCity, {
                shouldDirty: true,
            });
            setValue("billingState", billingInfoUpdate.billingState, {
                shouldDirty: true,
            });
            setValue("billingPostalCode", billingInfoUpdate.billingPostalCode, {
                shouldDirty: true,
            });
            setValue("cardLast4", billingInfoUpdate.cardNumber.replace(/\s+/g, "").slice(-4), {
                shouldDirty: true,
            });
            setValue("cardExpirationDate", billingInfoUpdate.expDate, {
                shouldDirty: true,
            });
            setFullBillingAddress(`${billingInfoUpdate.billingAddress}, ${billingInfoUpdate.billingCity}, ${billingInfoUpdate.billingState} ${billingInfoUpdate.billingPostalCode}`)
            const parts = billingInfoUpdate.expDate.split('/');
            if (parts.length !== 2) {
                notificationService.error("Invalid expiration format. Expected MM/YY.");
                return;
            }
            const [month, year] = parts;
            customerData.cardExpirationMonth = month;
            customerData.cardExpirationYear = year;
        }
    }, [billingInfoUpdate]);

    useEffect(() => {
        if(place){
            const splitAddress = SplitAddressFromGoogleAddressComponents(place.address_components)
            setValue("standardizedAddress", place.formatted_address);
            setValue("streetNumber", splitAddress.streetNumber);
            setValue("streetPrefix", splitAddress.streetPrefix);
            setValue("streetName", splitAddress.streetName);
            setValue("streetSuffix", splitAddress.streetSuffix);
            setValue("streetPostDirection", splitAddress.streetPostDirection);
            setValue("city", splitAddress.city);
            setValue("county",splitAddress.county);
            setValue("state", splitAddress.state);
            setValue("postalCode", splitAddress.postalCode);
            setPlaceChanged(true)
        }
    }, [place]);
    
    
    
    const handleKeyDown = useCallback((e: KeyboardEvent) => {
        if (e.ctrlKey && e.key.toLowerCase() === 's') {
            e.preventDefault();
            onSubmit(getValues());             
        }
    }, [onSubmit]);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);

    useEffect(() => {
        const refreshListener = () => {
            const all = getValues()
            onSubmit(all);
        }
        eventEmitter.on(EventEmitterTypes.CUSTOMER_SAVE, refreshListener);
        eventEmitter.emit(EventEmitterTypes.CLOSE_SIDEBAR)
        

        return () => {
            eventEmitter.off(EventEmitterTypes.CUSTOMER_SAVE, refreshListener);
            const wasOpen = JSON.parse(sessionStorage.getItem('sidebarWasOpen') || 'true');
            eventEmitter.emit(wasOpen ? EventEmitterTypes.OPEN_SIDEBAR : EventEmitterTypes.CLOSE_SIDEBAR);
            sessionStorage.removeItem('sidebarWasOpen');
        };
    }, []);
    function SplitBillingCityStatePostal(splitBy: 'city' | 'state' | 'postal', billing): string {
        if(!billing) return ''
        const [city, stateAndPostal] = billing.split(', ');
        const [state, postal] = stateAndPostal.split(' ');
        if (splitBy === 'city')   return city;
        if (splitBy === 'state')  return state;
        if (splitBy === 'postal') return postal;
        return '';
    }

    useEffect(() => {
        register('billingCity');
        register('billingState');
        register('billingPostalCode');
        register('billingAddress');
        register('billingName');
        register('county');
    }, [register]);
    
    const showActiveYears = watch('jobHistorySelectionDropdown');

    useEffect(() => {
        if(customerData){
            setBillingModalInfo({
                billAddress: customerData?.billingAddress,
                billPostal: customerData?.billingPostalCode,
                billState: customerData?.billingState,
                billCity: customerData?.billingCity,
                billingName: customerData?.billingName,
            })
            let billingString = isNullOrEmpty(customerData.billingAddress) ? '' : customerData.billingAddress +  ', '
            billingString += isNullOrEmpty(customerData.billingCity) ? '' : customerData.billingCity +  ', '
            billingString += isNullOrEmpty(customerData.billingState) ? '' : customerData.billingState
            billingString += isNullOrEmpty(customerData.billingPostalCode) ? '' : customerData.billingPostalCode
            setFullBillingAddress(billingString)
        }
    }, [customerData]);

    useEffect(() => {
        (async () => {
            const customerStatuses = await listService.getCustomerStatuses();
            setCustomerStatuses(customerStatuses)
            const businessYearsRes = await businessYearService.getBusinessYears();
            const currentYear = businessYearsRes.filter(x => x.current)[0];
            setCurrentYear(currentYear.year);
        })();
    }, []);

    useEffect(() => {
        if (!state.customerId) return;

        let isCancelled = false;
        const fetchCustomer = async () => {
            setLoading(true);
            try {
                const customerRes = await customerService.getCustomerById(state.customerId);
                const customerImage = await customerService.getBase64ImageByCustomerId(state.customerId);

                if (isCancelled) return;

                if(!customerRes.standardizedAddress){
                    customerRes.standardizedAddress = formatStandardizedAddress(customerRes)
                }
                if (!customerImage) {
                    GetStaticImageOfCustomer(customerRes);
                } else {
                    setMapBase64String(customerImage.imageDataBase64);
                }

                if (isCancelled) return;

                setCustomerData(customerRes);
                reset(customerRes);           
                const jobsRes = await customerService.getCustomerJobsByCustomerId(state.customerId);
                if (isCancelled) return;
                setJobData(jobsRes);
                if(customerRes.linkCode && customerRes.linkCode != ''){
                    const linkedAddressesRes = await customerService.getLinkedAddresses(customerRes.linkCode);
                    if (isCancelled) return;
                    setLinkedAddresses(linkedAddressesRes)
                }
            } finally {
                if (!isCancelled) setLoading(false);
            }
        };

        fetchCustomer();

        return () => {
            isCancelled = true;
        };
    }, [state.customerId]);

    function buildUrl(width: number, height: number, address: string) {
        const zoom = '20'
        const params = new URLSearchParams({
            center:   address,
            zoom,
            size:     `${width}x${height}`,
            maptype:  "hybrid",
            key:      google_api_key
        });

        return `https://maps.googleapis.com/maps/api/staticmap?${params.toString()}`;
    }
    async function GetStaticImageOfCustomer(customerDetails: any) {
        const address = formatStandardizedAddress(customerDetails);
        const base64String = await capture(address)
        setMapBase64String(base64String)
        await customerService.saveMapBase64ByCustomerId(customerDetails.customerId, base64String)
    }
    const capture = async (address: string): Promise<string> => {

        let side = 1024;
        let blob: Blob;
        const MIN_SIDE = 128;
        const STEP = 32;
        const TARGET = 256_000;
        do {
            const url = buildUrl(side, side, address);
            const res = await fetch(url);
            if (!res.ok) throw new Error(res.statusText);
            blob = await res.blob();

            if (blob.size > TARGET) {
                side = Math.max(MIN_SIDE, side - STEP);
            }
        } while (blob.size > TARGET && side > MIN_SIDE);

        return await blobToBase64(blob);
    };

    const blobToBase64 = (blob: Blob): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const dataUrl = reader.result as string;
                resolve(dataUrl.split(',')[1] || '');
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });

    const jobsByYear = useMemo(() => {
        if(!jobData) return;
        return jobData.reduce((acc: Record<number, any[]>, job: any) => {
            const year = job.businessYear;
            if (!acc[year]) acc[year] = [];
            acc[year].push(job);
            return acc;
        }, {});
    }, [jobData]);

    const sortedYears = useMemo(
        () => Object.keys(jobsByYear)
            .map((y) => Number(y))
            .sort((a, b) => b - a),
        [jobsByYear]
    );
    
    function getMapBase64String() {
        if(mapBase64String && mapBase64String !== '')
            return `url("data:image/png;base64,${mapBase64String}")`
        else 
            return ''
    }
    
    function getJobEstimate(job: any) {
        return Math.ceil(Number(job.sealcoatingPrice) +
                Number(job.patchworkPrice) +
                Number(job.hotPatchworkPrice) +
                Number(job.sawCutPrice) +
                Number(job.stripingPrice) +
                Number(job.crackSealPrice) +
                Number(job.hotCrackSealPrice));
    }
    
    function shouldShowLinkModal(billingInfoUpdate: any) {
        const authData = {
            clientKey: authorize_net_client_key,
            apiLoginID: authorize_net_login_id,
        };
        const parts = billingInfoUpdate.expDate.split('/');
        if (parts.length !== 2) {
            notificationService.error("Invalid expiration format. Expected MM/YY.");
            return;
        }
        const [month, year] = parts;
        let normalizedYear = year;
        if (year.length === 2) {
            normalizedYear = `20${year}`;
        }
        const cardData = { cardNumber: billingInfoUpdate.cardNumber.replace(/\s/g, ''), month, year: normalizedYear, cardCode: billingInfoUpdate.securityCode };
        const billing = { fullName: billingInfoUpdate.name};

        const secureData = { authData, cardData, billing };

        function onTokenForValidation(dataValue: any, dataDescriptor: any, billingInfoUpdate: any) {
            setShowBillingModal(false)
            setBillingInfoUpdate(billingInfoUpdate)
            if(linkedAddresses && linkedAddresses.length > 1) {
                setShowCCModal(true)
            } else {
                setUpdateCustomerIdBillingInfo([customerData?.customerId])
            }
        }

        const callback = (response: any) => {
                if (response.messages.resultCode === "Error") {
                    const msg = response.messages.message[0];
                    console.log(`${msg.code}: ${msg.text}`);
                    notificationService.error(msg.text)
                } else {
                    const { dataValue, dataDescriptor } = response.opaqueData;
                    onTokenForValidation(dataValue, dataDescriptor, billingInfoUpdate);
                }
            };
        accept.dispatchData(secureData, callback);
    }

    

    const dirtyPropertyCard = dirtyFields.propertyType || dirtyFields.businessName || dirtyFields.streetNumber || 
        dirtyFields.streetPrefix || dirtyFields.streetName || dirtyFields.streetSuffix || dirtyFields.city ||
        dirtyFields.streetPostDirection || dirtyFields.state || dirtyFields.postalCode || dirtyFields.standardizedAddress;
    const dirtyCustomerCard = dirtyFields.customerStatusId || dirtyFields.customerClassification || dirtyFields.customerId || dirtyFields.webId ||
        dirtyFields.firstName || dirtyFields.lastName || dirtyFields.email || dirtyFields.link || dirtyFields.workPhone || dirtyFields.homePhone;
    const dirtyBillingCard = dirtyFields.billingName || dirtyFields.billingAddress || dirtyFields.billingCity || dirtyFields.billingPostalCode ||
        dirtyFields.last4CardNumber || dirtyFields.cardExpirationDate || dirtyFields.billingState;

    function hasLegacyData(job: any) {
        return job.legacyAmountOnFlyer || job.legacyOriginalEstimate || job.legacyAmountOfEstimate || job.legacyAmountCharged || job.legacyAmountReceived;
    }

    return (
        <>
            <form style={{display: 'contents'}} onSubmit={handleSubmit(onSubmit)}>
                <div className='customerPage'>
                    {/*<!-- start customer/job header -->*/}
                    <div className="customerHeader">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="breadcrumbs mb-3">
                                <a style={{cursor: "pointer",}} onClick={() => navigate("/admin/customers")}
                                   className="levelUp">
                                    search results
                                </a>
                                <span className="levelDirection">
                            <i className="fa-regular fa-angle-right"></i>
                            </span>
                            <span className="levelCurrent">
                                customer
                            </span>
                            </div>
                            <div>
                                <button onClick={() => navigate("/admin/customers")} type={'button'}
                                        className="btn btn-light px-3 me-2">cancel
                                </button>
                               
                                <button type='submit' className="btn btn-primary px-3 hvr-grow">
                                    <i className="fa-regular fa-floppy-disk"></i> save
                                </button>
                            </div>
                        </div>
                        <div className="customerInfo">
                            <div>
                                {customerData &&
                                    <>
                                        <h1 className="levelName mb-0">
                                            {getBusinessOrCustomerName(customerData)}
                                        </h1>
                                        <h2 className="levelSecondary mb-0">
                                            {customerData?.standardizedAddress}
                                        </h2>
                                    </>
                                }

                            </div>
                        </div>

                    </div>


                    <div className="container weirdHeader">
                        {/*<!-- start group PROPERTY -->*/}
                        <div className="row">
                            <div className="col">
                                {/*<!-- start group PROPERTY -->*/}
                                <div className={"card shadow-sm rounded-lg" +
                                    (dirtyPropertyCard ? " editMade" : "")
                                }>
                                <div className="card-body p-4">
    
                                        <div className="row">
                                            <div className="col-lg-6">
                                            <div className="row">
                                                    <div className="col">
                                                        <h2 className="catName">
                                                        <span className="catIcon">
                                                            <i className="fa-solid fa-house"></i>
                                                        </span>
                                                            Property
                                                        </h2>
                                                    </div>
                                                </div>
    
                                                <div className="row g-2">
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="selectInput"
                                                               className={"form-label" + (dirtyFields.propertyType ? " fieldEdit" : "")}>Type</label>
                                                        <select {...register("propertyType")}
                                                                className="form-select form-select-sm"
                                                                aria-label="Property Type" id="selectInput">
                                                            <option value="Unspecified" selected>Select</option>
                                                            <option value="Residential">Residential</option>
                                                            <option value="Commercial">Commercial</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6 mb-3cd">
                                                        <label htmlFor="textInput"
                                                               className={"form-label" + (dirtyFields.businessName ? " fieldEdit" : "")}>Business
                                                            Name</label>
                                                        <input {...register("businessName")} type="text" className="form-control form-control-sm"
                                                               id="textInput" aria-describedby="textInput"
                                                               placeholder="text" disabled={getValues().propertyType !== 'Commercial'}/>
                                                    </div>
                                                </div>
    
                                                {/*<div className="row g-2">
                                                    <div className="col-md-2 mb-3">
                                                        <label htmlFor="textInput" className={"form-label"+(dirtyFields.streetNumber ? " fieldEdit" : "")}>StNum</label>
                                                        <input {...register("streetNumber")} type="text" className="form-control form-control-sm"
                                                               id="textInput" aria-describedby="textInput"
                                                               placeholder="text"/>
                                                    </div>
                                                    <div className="col-md-2 mb-3">
                                                        <label htmlFor="textInput" className={"form-label"+(dirtyFields.streetPrefix ? " fieldEdit" : "")}>Prefix</label>
                                                        <input {...register("streetPrefix")} type="text" className="form-control form-control-sm"
                                                               id="textInput" aria-describedby="textInput"
                                                               placeholder="text"/>
                                                    </div>
                                                    <div className="col-md-4 mb-3">
                                                        <label htmlFor="textInput" className={"form-label"+(dirtyFields.streetName ? " fieldEdit" : "")}>Street
                                                            Name</label>
                                                        <input {...register("streetName")} type="text" className="form-control form-control-sm"
                                                               id="textInput" aria-describedby="textInput"
                                                               placeholder="text"/>
                                                    </div>
                                                    <div className="col-md-2 mb-3">
                                                        <label htmlFor="textInput" className={"form-label"+(dirtyFields.streetSuffix ? " fieldEdit" : "")}>Suffix</label>
                                                        <input {...register("streetSuffix")} type="text" className="form-control form-control-sm"
                                                               id="textInput" aria-describedby="textInput"
                                                               placeholder="text"/>
                                                    </div>
                                                    <div className="col-md-2 mb-3">
                                                        <label htmlFor="textInput" className={"form-label"+(dirtyFields.streetPostDirection ? " fieldEdit" : "")}>PostDir</label>
                                                        <input {...register("streetPostDirection")} type="text" className="form-control form-control-sm"
                                                               id="textInput" aria-describedby="textInput"
                                                               placeholder="text"/>
                                                    </div>
                                                </div>
    
                                                <div className="row g-2">
                                                    <div className="col-md-8 mb-3">
                                                        <label htmlFor="textInput" className={"form-label"+(dirtyFields.city ? " fieldEdit" : "")}>City</label>
                                                        <input {...register("city")} type="text" className="form-control form-control-sm"
                                                               id="textInput" aria-describedby="textInput"
                                                               placeholder="text"/>
                                                    </div>
                                                    <div className="col-md-2 mb-3">
                                                        <FormSelectCustom
                                                            label="State"
                                                            name="state"
                                                            dirtyField={dirtyFields.state}
                                                            register={register}
                                                            options={states}
                                                        />
                                                    </div>
                                                    <div className="col-md-2 mb-3">
                                                        <label htmlFor="textInput" className={"form-label"+(dirtyFields.postalCode ? " fieldEdit" : "")}>Zip</label>
                                                        <input {...register("postalCode")} type="text" className="form-control form-control-sm"
                                                               id="textInput" aria-describedby="textInput"
                                                               placeholder="text"/>
                                                    </div>
                                                </div>*/}
    
                                                <div className="row g-2">
                                                    <div className="col-md-12 mb-3">
                                                        <label htmlFor="textInput" className={"form-label"+(dirtyFields.standardizedAddress ? " fieldEdit" : "")}>Standardized
                                                            Address</label>
                                                        <AutocompleteAddressInput defaultValue={getValues().standardizedAddress} onLocation={(place) => {}} setPlace={setPlace} className={"form-control form-control-sm"} loadGoogle/>
                                                    </div>
                                                </div>
    
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="mapContainer">
                                                    {mapBase64String !== '' && <div className="mapCanvas"
                                                         style={{backgroundImage: getMapBase64String()}}/>}
                                                </div>
                                            </div>
                                        </div>
    
                                    </div>
                                </div>
                                {/*<!-- end group -->*/}
                            </div>
                        </div>
    
    
                        <div className="row">
    
    
                            {/*<!-- LEFT COL -->*/}
                            <div className="col-lg-5">
    
    
                                {/*<!-- start group CUSTOMER -->*/}
                                <div className={"card shadow-sm rounded-lg"+
                                (dirtyCustomerCard ? " editMade" : "")
                                }>
                                    <div className="card-body p-4">
                                        <div className="row">
                                            <div className="col">
                                                <h2 className="catName">
                                                <span className="catIcon">
                                                    <i className="fa-solid fa-user"></i>
                                                </span>
                                                    Customer
                                                </h2>
                                            </div>
                                        </div>

                                        <div className="row g-2">
                                            <div className="col-md-12 mb-3">
                                                <FormSelectCustom
                                                    label="Customer Status"
                                                    name="customerStatusId"
                                                    register={register}
                                                    options={customerStatusOptions}
                                                    dirtyField={dirtyFields.customerStatusId}
                                                />
                                            </div>
                                            {/*<div className="col-md-6 mb-3">
                                                <label htmlFor="selectInput" className={"form-label"+(dirtyFields.customerClassification ? " fieldEdit" : "")}>Customer
                                                    Classification</label>
                                                <select {...register("customerClassification")} className="form-select form-select-sm" aria-label="selectInput"
                                                        id="selectInput">
                                                    <option selected>Select</option>
                                                    <option value="1">C</option>
                                                    <option value="2">something else</option>
                                                </select>
                                            </div>*/}
                                        </div>

                                        <div className="row g-2">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="textInput"
                                                       className={"form-label" + (dirtyFields.customerNumber ? " fieldEdit" : "")}>Customer
                                                    ID</label>
                                                <input {...register("customerNumber")} type="text"
                                                       className="form-control form-control-sm" id="textInput"
                                                       aria-describedby="textInput" placeholder="text"/>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="textInput"
                                                       className={"form-label" + (dirtyFields.webId ? " fieldEdit" : "")}>Web
                                                    ID</label>
                                                <input {...register("webId")} type="text"
                                                       className="form-control form-control-sm" id="textInput"
                                                       aria-describedby="textInput" placeholder="text"/>
                                            </div>
                                        </div>

                                        <div className="row g-2">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="textInput"
                                                       className={"form-label" + (dirtyFields.firstName ? " fieldEdit" : "")}>First
                                                    Name</label>
                                                <input {...register("firstName")} type="text"
                                                       className="form-control form-control-sm" id="textInput"
                                                       aria-describedby="textInput" placeholder="text"/>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="textInput"
                                                       className={"form-label" + (dirtyFields.lastName ? " fieldEdit" : "")}>Last
                                                    Name</label>
                                                <input {...register("lastName")} type="text"
                                                       className="form-control form-control-sm" id="textInput"
                                                       aria-describedby="textInput" placeholder="text"/>
                                            </div>
                                        </div>
                                        
                                        <div className="row g-2">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="textInput"
                                                       className={"form-label" + (dirtyFields.homePhone ? " fieldEdit" : "")}>Home Phone</label>
                                                <input {...register("homePhone")} type="text"
                                                       className="form-control form-control-sm" id="textInput"
                                                       aria-describedby="textInput" placeholder="text"/>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="textInput"
                                                       className={"form-label" + (dirtyFields.workPhone ? " fieldEdit" : "")}>Work Phone</label>
                                                <input {...register("workPhone")} type="text"
                                                       className="form-control form-control-sm" id="textInput"
                                                       aria-describedby="textInput" placeholder="text"/>
                                            </div>
                                        </div>
                                        
                                        <div className="row g-2">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="textInput"
                                                       className={"form-label" + (dirtyFields.email ? " fieldEdit" : "")}>Email</label>
                                                <input {...register("email")} type="text"
                                                       className="form-control form-control-sm" id="textInput"
                                                       aria-describedby="textInput" placeholder="text"/>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="textInput"
                                                       className={"form-label" + (dirtyFields.linkCode ? " fieldEdit" : "")}>Link</label>
                                                <input {...register("linkCode")} type="text"
                                                       className="form-control form-control-sm" id="textInput"
                                                       aria-describedby="textInput" placeholder="text"/>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                                {/*<!-- end group -->*/}


                                {/*<!-- start group BILLING -->*/}
                                {/*<!-- editMade class -->*/}
                                <div className={"card shadow-sm rounded-lg" +
                                    (dirtyBillingCard ? " editMade" : "")
                                }>
                                    <div className="card-body p-4">
                                        <div className="row">
                                            <div className="catName col d-flex px-0 mx-2 justify-content-between">
                                                <h2 className="mb-0">
                                                <span className="catIcon">
                                                    <i className="fa-solid fa-credit-card"></i>
                                                </span>
                                                    Billing
                                                </h2>
                                                <a className="truckEdit action" style={{cursor: "pointer",}}
                                                   onClick={() => setShowBillingModal(true)}>
                                                <i className="fa-regular fa-pencil"></i> edit
                                                </a>
                                            </div>
                                        </div>
    
                                        <div className="row g-2">
                                            <div className="col-12 mb-3">
                                                <label htmlFor="textInput"
                                                       className={"form-label" + (dirtyFields.billingName ? " fieldEdit" : "")}>Name</label>
                                                <input disabled {...register("billingName")} type="text" className="form-control form-control-sm" id="textInput"
                                                       aria-describedby="textInput" placeholder="text"/>
                                            </div>
                                            <div className="col-12 mb-3">
                                                <label htmlFor="textInput" className={"form-label"+(dirtyFields.billingAddress ? " fieldEdit" : "")}>Billing Address</label>
                                                <input disabled value={fullBillingAddress} type="text" className="form-control form-control-sm" id="textInput"
                                                       aria-describedby="textInput" placeholder="text"/>
                                            </div>
                                        </div>
    
                                        <div className="row g-2">
                                            <div className="col-md-8 mb-3">
                                                <label htmlFor="textInput" className={"form-label"+(dirtyFields.cardLast4 ? " fieldEdit" : "")}>Card Number (last 4
                                                    digits)</label>
                                                <input disabled {...register("cardLast4")} type="text" className="form-control form-control-sm" id="textInput"
                                                       aria-describedby="textInput" placeholder="text"/>
                                            </div>
                                            <div className="col-md-4 mb-3">
                                                <label htmlFor="textInput" className={"form-label"+(dirtyFields.cardExpirationDate ? " fieldEdit" : "")}>Exp</label>
                                                <input disabled value={customerData ? customerData.cardExpirationMonth + '/' + String(customerData.cardExpirationYear % 100).padStart(2, '0') : ''} type="text" className="form-control form-control-sm" id="textInput"
                                                       aria-describedby="textInput" placeholder="text"/>
                                            </div>
                                        </div>
    
    
                                    </div>
                                </div>
                                {/*<!-- end group -->*/}
                            </div>
    
    
                            {/*<!-- RIGHT COL -->*/}
                            <div className="col-lg-7">
    
                                <div className="jobHistory mt-2">
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                        <h3 className="mb-0">
                                            Job History
                                        </h3>
                                        <a onClick={() => setShowJobModal(true)} className="fw-medium" data-bs-toggle="modal"
                                           data-bs-target="#newJobModal">+ new job</a>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between mb-4">
                                    <span className="mb-0">
                                        <small className="text-muted fst-italic">{jobData.length} jobs</small>
                                    </span>
                                        <select {...register("jobHistorySelectionDropdown")}
                                                className="form-select form-select-sm w-auto" aria-label="selectInput"
                                                id="selectInput">
                                            <option value="0" selected>show all years</option>
                                            <option value="1">show active years</option>
                                        </select>
                                    </div>
                                    <div className="jobList">
                                        {sortedYears.map((year) => (
                                            <div key={year} className="jobCard">
                                                <div className="jobHeader">
                                                <h4 className="mb-0">{year}</h4>
                                            </div>
                                        
                                        {jobsByYear[year].filter(job => showActiveYears !== "1" || job.jobStatusId !== 1).map((job: any) => {
                                                return (
                                                    <>
                                                        {hasLegacyData(job) &&
                                                            <div key={job.jobId} className="jobInfo">
                                                                <div className="row align-items-center">
                                                                    <div className="col-lg-2 align-items-center">
                                                                    <span
                                                                        className={`jobBadge ${(job.jobStatusId === 3 ? ' infull' : '')}`}>
                                                                    {job.jobStatusName}
                                                                    </span>
                                                                    </div>
                                                                    <div className="col-lg-3">
                                                                        <div className="infoBlock">
                                                                            <span className="infoLabel">Estimate</span>
                                                                            <span
                                                                                className="infoData">AmtOfEst: ${job.legacyAmountOfEstimate}</span>
                                                                            <span
                                                                                className="infoData">Original Est: ${job.legacyOriginalEstimate}</span>
                                                                        </div>
                                                                    </div>
            
                                                                    <div className="col-lg-2">
                                                                        <div className="infoBlock">
                                                                            <span className="infoLabel">Service</span>
                                                                            <span className="infoData">{job.dateDone
                                                                                ? new Date(job.dateDone)
                                                                                    .toLocaleDateString('en-US', {
                                                                                        timeZone: 'UTC',
                                                                                        year: 'numeric',
                                                                                        month: 'short',
                                                                                        day: 'numeric',
                                                                                    })
                                                                                : 'N/A'}</span>
            
                                                                            <span className="infoData">Flyer: ${job.legacyAmountOnFlyer}</span>
            
                                                                        </div>
                                                                    </div>
            
                                                                    <div className="col-lg-3">
                                                                    <div className="infoBlock">
                                                                            <span className="infoLabel">Payment</span>
                                                                            <span
                                                                                className="infoData">Charged: ${job.legacyAmountCharged}</span>
                                                                            <span
                                                                                className="infoData">Received: ${job.legacyAmountReceived}</span>
                                                                        </div>
                                                                    </div>
            
                                                                    <div className="col-lg-2 ms-auto d-flex justify-content-end">
                                                                        <a
                                                                            onClick={() => navigate(`/admin/job-details`, {
                                                                                state: {
                                                                                    jobId: job.jobId,
                                                                                    customerId: state.customerId,
                                                                                    customerName: state.customerName ?? getBusinessOrCustomerName(customerData),
                                                                                    propertyAddress: customerData.standardizedAddress
                                                                                }
                                                                            })}
                                                                            className="viewJob text-end"
                                                                            style={{cursor: "pointer",}}>
                                                                            <i className="fa-regular fa-eye"/> view
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {!hasLegacyData(job) &&
                                                            <div key={job.jobId} className="jobInfo">
                                                                <div className="row align-items-center">
                                                                    <div className="col-lg-2 align-items-center">
                                                                    <span
                                                                        className={`jobBadge ${(job.jobStatusId === 3 ? ' infull' : '')}`}>
                                                                    {job.jobStatusName}
                                                                    </span>
                                                                    </div>
                                                                    <div className="col-lg-3">
                                                                        <div className="infoBlock">
                                                                            <span className="infoLabel">Estimate</span>
                                                                            <span className="infoData">{job.dateEstimated
                                                                                ? new Date(job.dateEstimated)
                                                                                    .toLocaleDateString('en-US', {
                                                                                        timeZone: 'UTC',
                                                                                        year: 'numeric',
                                                                                        month: 'short',
                                                                                        day: 'numeric',
                                                                                    })
                                                                                : 'N/A'}</span>
                                                                            <span className="infoData">${job.jobEstimate}</span>
                                                                        </div>
                                                                    </div>
            
                                                                    <div className="col-lg-2">
                                                                        <div className="infoBlock">
                                                                            <span className="infoLabel">Service</span>
                                                                            <span className="infoData">{job.dateDone
                                                                                ? new Date(job.dateDone)
                                                                                    .toLocaleDateString('en-US', {
                                                                                        timeZone: 'UTC',
                                                                                        year: 'numeric',
                                                                                        month: 'short',
                                                                                        day: 'numeric',
                                                                                    })
                                                                                : 'N/A'}</span>
                                                                            <span className="infoData">${job.totalJobPrice}</span>
            
                                                                        </div>
                                                                    </div>
            
                                                                    <div className="col-lg-3">
                                                                        <div className="infoBlock">
                                                                            <span className="infoLabel">Payment</span>
                                                                            <span className="infoData">{job.dm
                                                                                ? new Date(job.dm)
                                                                                    .toLocaleDateString('en-US', {
                                                                                        timeZone: 'UTC',
                                                                                        year: 'numeric',
                                                                                        month: 'short',
                                                                                        day: 'numeric',
                                                                                    })
                                                                                : 'N/A'}</span>
                                                                            <span
                                                                                className="infoData">${job.totalAmountReceived}</span>
                                                                        </div>
                                                                    </div>
            
                                                                    <div className="col-lg-2 ms-auto d-flex justify-content-end">
                                                                        <a
                                                                            onClick={() => navigate(`/admin/job-details`, {
                                                                                state: {
                                                                                    jobId: job.jobId,
                                                                                    customerId: state.customerId,
                                                                                    customerName: state.customerName ?? getBusinessOrCustomerName(customerData),
                                                                                    propertyAddress: customerData.standardizedAddress
                                                                                }
                                                                            })}
                                                                            className="viewJob text-end"
                                                                            style={{cursor: "pointer",}}>
                                                                            <i className="fa-regular fa-eye"/> view
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </>
                                                )

                                        })}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <NewJobModal show={showJobModal} toggle={() => setShowJobModal(false)}
                         refreshData={async () => setJobData(await customerService.getCustomerJobsByCustomerId(state.customerId))}
                         customerId={state.customerId} businessYear={currentYear}/>
            <LinkCCModal show={showCCModal} toggle={() => setShowCCModal(false)} onSubmit={(data) => {
                setUpdateCustomerIdBillingInfo(data);
                setShowCCModal(false)
            }} allAddresses={linkedAddresses} currentCustomerId={state.customerId}/>
            <BillingInfoModal
                billingInfo={billingModalInfo}
                customerAddress={{address: customerData?.standardizedAddress.split(',')[0], city: customerData?.city, state: customerData?.state, zip: customerData?.postalCode, name: customerData?.firstName ? `${customerData.firstName} ${customerData.lastName}` : customerData?.lastName}}
                show={showBillingModal} toggle={() => setShowBillingModal(false)} onSubmit={(data) => {
                shouldShowLinkModal(data)
            }}/>
        </>
    );
}

export default CustomerDetailsPage;